import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Maze from './Maze';

const element = <Maze></Maze>
ReactDOM.render(element, document.getElementById("root"));
